import { useState } from "react";

const faqs = [
  {
    id: 1,
    question: "What makes term insurance the best choice for families?",
    answer:
      "Term insurance is the simplest and most affordable form of life insurance. You pay a low premium to secure a high sum assured for your family. In case of your untimely demise during the policy term, your nominees receive the entire sum assured as a financial safety net. With insurers like Future Generali, Max Life, and Bajaj Allianz available through Fintoo, you get trusted protection for your loved ones."
  },
  {
    id: 2,
    question: "How much life insurance cover should I take?",
    answer:
      "As a thumb rule, aim for coverage equal to at least 10–15 times your annual income. This ensures your family can cover daily living expenses, repay loans, fund children’s education, and achieve long-term financial goals. For example, with an annual income of ₹10 lakhs, you should consider a cover between ₹1 crore to ₹1.5 crores."
  },
  {
    id: 3,
    question: "What if I survive the policy term?",
    answer:
      "A pure term insurance plan does not pay out if you survive the policy term—this is why the premium is low compared to other life insurance products. However, some insurers also offer ‘Return of Premium’ (ROP) options where all premiums paid are refunded at maturity. You can choose between pure protection or ROP plans depending on your needs."
  },
  {
    id: 4,
    question: "Can I add riders later?",
    answer:
      "Yes, many insurers allow you to enhance your base cover by adding riders such as Critical Illness, Accidental Death Benefit, Waiver of Premium, and more. Some riders can be added at the time of purchase, and certain policies also allow you to add them later during key life events like marriage or childbirth. It’s advisable to plan riders at the time of buying for comprehensive protection."
  },
  {
    id: 5,
    question: "Which insurer has the best claim settlement ratio?",
    answer:
      "Fintoo works with leading insurers like Future Generali, Max Life, and Bajaj Allianz—each with a strong claim settlement record above 95%. The claim settlement ratio reflects the insurer’s reliability in honoring claims, and with these trusted partners, you can be assured of a smooth and transparent claims process."
  },
  {
    id: 6,
    question: "Is buying online safe and reliable?",
    answer:
      "Absolutely. Purchasing term insurance online through Fintoo is 100% safe, quick, and transparent. You can compare plans from Future Generali, Max Life, and Bajaj Allianz in one place, customize coverage, and complete the process digitally. All policies issued are valid and regulated by IRDAI, so your protection is fully secured."
  },
  {
    id: 7,
    question: "How soon does coverage begin after purchase?",
    answer:
      "Once your application is submitted and medical tests (if required) are cleared, your policy is issued and coverage begins immediately. In most cases, policies from Max Life, Future Generali, and Bajaj Allianz get approved within a few working days."
  },
  {
    id: 8,
    question: "Do I need medical tests to buy term insurance?",
    answer:
      "Medical tests depend on your age, coverage amount, and health declarations. For higher coverage (like ₹1 crore+), insurers generally require basic health checkups. These tests ensure accurate underwriting and keep future claim settlements hassle-free."
  },
  {
    id: 9,
    question: "What happens if I miss a premium payment?",
    answer:
      "Most policies provide a grace period (usually 15–30 days) to pay your missed premium. If you fail to pay within this time, the policy may lapse, and your family may lose protection. Fintoo helps you with reminders so your policy stays active."
  },
  {
    id: 10,
    question: "Can NRIs purchase term insurance from India?",
    answer:
      "Yes, NRIs can buy term insurance from Indian insurers like Max Life, Future Generali, and Bajaj Allianz through Fintoo. Some additional documentation may be required depending on your country of residence."
  },
];


export default function FAQSection() {
  const [openId, setOpenId] = useState(null);

  const toggleFaq = (id) => {
    setOpenId(openId === id ? null : id);
  };
 
  return (
    <section id="faq" className="lg:tw-py-20 tw-py-10 tw-bg-gray-50">
      <div className="tw-max-w-4xl tw-mx-auto tw-px-6">
        <div className="tw-text-center tw-mb-16">
          <h2 className="tw-text-2xl lg:tw-text-4xl tw-font-bold tw-text-fintoo-blue tw-mb-6">
            Frequently Asked Questions
          </h2>
          <p className="tw-text-lg  lg:tw-text-xl  tw-text-gray-700">
            Get answers to common questions about term insurance
          </p>
        </div>

        <div className="tw-space-y-4">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className=" tw-rounded-xl tw-border tw-border-solid tw-border-gray-200 tw-overflow-hidden"
            >
              <button
                onClick={() => toggleFaq(faq.id)}
                className="tw-w-full tw-bg-white tw-px-6 tw-py-5 tw-text-left tw-flex tw-justify-between tw-items-center hover:tw-bg-gray-50 tw-transition-colors"
              >
                <span className="tw-text-lg tw-font-semibold tw-text-fintoo-blue">
                  {faq.question}
                </span>
                <i
                  className={`fa-solid fa-chevron-down tw-text-fintoo-orange tw-transition-transform ${
                    openId === faq.id ? "tw-rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openId === faq.id && faq.answer && (
                <div className="tw-px-6 tw-pb-5">
                  <p className="tw-text-gray-700 tw-leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
